// extracted by mini-css-extract-plugin
export default {"documents":"Documents_documents__Aa92e"};